import type { QueryClient, QueryKey } from '@tanstack/react-query';
import type { TrackerEvidenceResponse, TrackerReviewDecision, TrackerTask } from '@shared/tracker-types';
import { buildTrackerReviewSummary } from '@shared/tracker-review-eligibility';

/** Called only after acknowledgement. Server refresh supplies authoritative decision metadata. */
export function acknowledgeEvidenceReview(client: QueryClient, key: QueryKey, eventId: number,
    decision: TrackerReviewDecision, feedbackText?: string, retailerReady = false): void {
    // Prevent a pre-decision read from replacing the acknowledged state.
    void client.cancelQueries({ queryKey: key, exact: true });
    client.setQueryData<TrackerEvidenceResponse>(key, (data) => {
        if (!data) return data;
        const update = (task: TrackerTask): TrackerTask => task.postingEventId !== eventId ? task : {
            ...task,
            reviewDecisionId: null,
            reviewDecidedBy: null,
            reviewDecidedAt: null,
            adminNotes: null,
            reviewStatus: decision === 'APPROVE' ? 'approved' : 'rejected',
            retailerReady: decision === 'APPROVE' && retailerReady,
            reviewFeedbackText: feedbackText?.trim() || null,
            rejectionNotes: decision === 'REJECT' ? feedbackText?.trim() || null : null,
        };
        const postings = data.postings.map(update);
        const removals = data.removals.map(update);
        return { ...data, postings, removals, reviewSummary: buildTrackerReviewSummary([...postings, ...removals]) };
    });
}
